import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import WBTable from "components/_WBcomponents/WBTable";
import { checkOutBooking, confirmBooking, getBookings, refundBooking, rejectBooking } from "services/bookingService";
import { Grid, Button, Dialog } from "@mui/material";
import { WBLabel, WBTitleLabel } from "components/_WBcomponents/WBLabel";
import moment from "moment";
import { currencyFormat } from "helper/numberHelper";
import { useDebounce } from "use-debounce";
import WBAccordion from "components/_WBcomponents/WBAccordion";
import ProductFilter from "./ProductFilter";
import { archiveProduct, getProductListv2 } from "services/productService";
import ProductForm from "./ProductForm";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

function ProductList ({
    
}) {

    const [ loading, setLoading ] = useState(false)
    const [ bookingData, setBookingData ] = useState([])
    const [ totalData, setTotalData ] = useState(0)
    const [ filter, setFilter ] = useState({
        skuId: "",
        productName: "",
        event: null,
        page: 0,
        isActive: null
    })

    const [ openDialog, setOpenDialog ] = useState({
        data: null,
        open: false
    })
    const [ alertArchive, setAlertArchive ] = useState({
        data: null,
        open: false
    })
    const [ productList, setProductList ] = useState([])

    const navigate = useNavigate()
    const [ debounceFilter ] = useDebounce(filter, 500)

    useEffect(() => {
        loadProductList()
    }, [debounceFilter])

    const loadProductList = async () => {
        let { data, error } = await getProductListv2({
            ...filter,
            event: filter.event ? filter.event.value : '',
            isActive: filter.isActive ? filter.isActive.value : '',
            limit: 20,
            page: filter.page
        })
        if (error) { console.log(error) }
        if (data) { setProductList(data.data); setTotalData(data.totalData) }
    }

    const valueCustomator = (data) => {
        return ({
            createdDate: <WBLabel>{moment(data.createdDate).format('DD-MM-YYYY HH:mm')}</WBLabel>,
            image: <img src={data.image} width={100} height={100}/>,
            // skuId: <WBLabel>{data.skuId || '-'}</WBLabel>,
            name: <WBLabel style={{
                cursor: 'pointer'
            }} onClick={() => {
                navigate(`/order/${data._id}`)
            }}><u>{data.name}</u></WBLabel>,
            eventName: <WBLabel>{data.event.eventName}</WBLabel>,
            stock: <WBLabel>{data.stock}</WBLabel>,
            price: <WBLabel>{currencyFormat(data.price)}</WBLabel>,
            action: <Grid container textAlign={"center"} justifyContent={"center"}>
                <div style={{ marginRight: 2, minWidth: 70, minHeight: 40, textAlign: 'center', display: 'flex' }}>
                    <Button color="warning" variant="contained" style={{
                        marginRight: 8
                    }} onClick={() => { 
                        setAlertArchive({
                            data: data,
                            open: true
                        })
                    }}>
                        <DeleteOutlined />
                    </Button>
                    <Button color="primary" variant="contained" onClick={() => {
                        setOpenDialog({
                            data: {
                                _id: data._id
                            },
                            open: true
                        })
                    }}>
                        <EditOutlined />
                    </Button>
                </div>
            </Grid>
        })
    }

    const onChangePage = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e
        }))
    }

    const confirmOrder = async (e) => {
        let { data, error } = await confirmBooking({
            id: e
        })
        if (error) { console.log(error) }
        if (data) { 
            loadProductList()
            setOpenDialog({
                data: null,
                open: false
            })
        }
    }

    const rejectOrder = async (e) => {
        let { data, error } = await rejectBooking({
            id: e
        })
        if (error) { console.log(error) }
        if (data) { 
            loadProductList()
            setOpenDialog({
                data: null,
                open: false
            })
        }
    }

    const refundOrder = async (e) => {
        let { data, error } = await refundBooking({
            id: e
        })
        if (error) { console.log(error) }
        if (data) { 
            loadProductList()
            setOpenDialog({
                data: null,
                open: false
            })
        }
    }

    const checkOutOrder = async (e) => {
        let { data, error } = await checkOutBooking({
            id: e
        })
        if (error) { console.log(error) }
        if (data) { 
            loadProductList()
            setOpenDialog({
                data: null,
                open: false
            })
        }
    }

    const onChangeFilter = (e) => {
        setFilter(prev => ({
            ...prev,
            ...e,
            page: 0
        }))
    }

    const archive = async (e) => {
        let { data, error } = await archiveProduct({productId: e})
        loadProductList()
        setAlertArchive({
            data: null,
            open: false
        })
    }

    return (
        <Grid>
            <Grid mb={1}>
                <Button variant="contained" onClick={() => {
                    setOpenDialog({
                        data: null,
                        open: true
                    })
                }}>Add New Product</Button>
            </Grid>
            <Grid sx={{mb: 1}}>
                <WBAccordion title={<WBLabel style={{fontWeight: 'bold'}}>{"Product Filter"}</WBLabel>}>
                    <ProductFilter
                        filter={filter}
                        onChangeFilter={onChangeFilter}
                        onClear={() => {
                            setFilter({
                                skuId: "",
                                productName: "",
                                event: null,
                                isActive: null
                            })
                        }}
                    />
                </WBAccordion>
            </Grid>
            <Grid>
                <WBTable
                    columns={[
                        { label: "Created Date" },
                        { label: "Image" },
                        // { label: "SkuId" },
                        { label: "Name" },
                        { label: "PO Event" },
                        { label: "Stock" },
                        { label: "Price" },
                    ]}
                    loading={loading}
                    valueCustomator={valueCustomator}
                    totalData={totalData}
                    rows={productList}
                    page={filter.page}
                    pageChange={(e) => {
                        onChangePage({page: e})
                    }}
                />
            </Grid>
            {
                openDialog.open &&
                <Dialog maxWidth={"xs"} open={openDialog.open} onClose={() => {
                    setOpenDialog({
                        data: null,
                        open: false
                    })
                }}>
                    <Grid>
                        <Grid pl={2} pr={2} pt={2} pb={2}>
                            <WBLabel style={{fontWeight: 'bold', fontSize: 16}}>Add new Product</WBLabel>
                        </Grid>
                        <ProductForm id={(openDialog && openDialog.data) ? openDialog.data._id : ''} loadData={() => {
                            setOpenDialog({
                                data: null,
                                open: false
                            })
                            loadProductList()
                        }} />
                    </Grid>
                </Dialog>
            }
            {
                alertArchive.open &&
                <Dialog maxWidth={"xs"} open={alertArchive.open} onClose={() => {
                    setAlertArchive({
                        data: null,
                        open: false
                    })
                }}>
                    <Grid container p={2}>
                        <Grid item xs={12}>
                            <WBLabel>Are you sure you want to archive this product ?</WBLabel>
                        </Grid>
                        <Grid container item xs={12} textAlign={"right"} mt={1}>
                            <Grid item xs></Grid>
                            <Grid item container xs>
                                <Grid item xs>
                                    <Button variant="outlined" style={{
                                        marginRight: 8
                                    }} onClick={() => { 
                                        setAlertArchive({
                                            data: null,
                                            open: false
                                        })
                                    }}>
                                        Close
                                    </Button>
                                </Grid>
                                <Grid>
                                    <Button color="primary" variant="contained" onClick={() => { archive(alertArchive.data._id) }}>
                                        Archive
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* archive(data._id)  */}
                </Dialog>
            }
        </Grid>
    )
}

export default ProductList